<template>
    <v-row>
        <v-col cols="12">
            <v-list>
                 <show-field :value="item.branch.name" :label="$t('delivery.stock.labels.branch')" icon="store"/>
            </v-list>
        </v-col>


        <v-col cols="12" >
          <v-row>
            <v-col v-for="(item,index) in item.items"
                   :key="index" cols="12" md="6">
              <product-stock
                  :product="item.product"
                  :in-stock="item.quantity"
                  readonly
              ></product-stock>
            </v-col>
          </v-row>
        </v-col>

    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'
    import ProductStock from "@/modules/delivery/components/ProductStock/ProductStock";


    export default {
        name: 'StockShowData',
        components: {ProductStock, ShowField},

        props: {
            item: {type: Object, required: true}
        }
    }
</script>

